export const boolToInt = (val: unknown): 1 | 0 => (!!val ? 1 : 0);
